const REFERENCE_FIELDS = [
  'id',
  'external_id',
  'cross_tenant_barcode',
]

export const normalizeOrderReference = value => String(value == null ? '' : value).trim()

const referenceCandidates = order => REFERENCE_FIELDS
  .map(field => normalizeOrderReference(order && order[field]))
  .filter(Boolean)

export const orderReferenceSearchValue = order => referenceCandidates(order).join(' ')

export const orderMatchesReference = (order, reference) => {
  const normalized = normalizeOrderReference(reference)
  if (!normalized || !order) return false

  if (referenceCandidates(order).includes(normalized)) return true

  // Cross-tenant labels are sometimes printed with DX while legacy scanners
  // submit only the numeric portion (and vice versa).
  const withoutPrefix = normalized.replace(/^DX/i, '')
  const crossTenantBarcode = normalizeOrderReference(order.cross_tenant_barcode)
  return Boolean(
    crossTenantBarcode
      && crossTenantBarcode.replace(/^DX/i, '') === withoutPrefix,
  )
}

export const orderReferenceContains = (order, reference) => {
  const normalized = normalizeOrderReference(reference).toLowerCase()
  if (!normalized || !order) return true
  return referenceCandidates(order).some(candidate => candidate.toLowerCase().includes(normalized))
}
